import React from "react";


export const Title = ({ children, style, extra }) => {
  return (
    <h3 style={{ marginBottom: 0, marginTop: 0, ...style }}>
      {children}
      {extra &&
        <div style={EXTRA_STYLE}>
          {extra}
        </div>
      }
    </h3>
  );
};


const EXTRA_STYLE = {
  float: 'right',
  marginLeft: 'auto',
};
